import React, { useEffect, useContext, useState } from 'react';
import axios from 'axios';
import $ from 'jquery';
import { NavLink } from 'react-router-dom';

import { LoginContext } from '../../hooks/context/LoginContext';

import Menusup from '../../componentes/menus/menusup/Menusup';
import Sidebar from '../../componentes/menus/sidebar/Sidebar';
import Formulario from '../../componentes/formulario/Formulario';
import FormRow from '../../componentes/formulario/FormRow';
import FormInput from '../../componentes/formulario/FormInput';
import TextArea from '../../componentes/formulario/TextArea';
import Footer from '../../componentes/footer/Footer';
import Section from '../../componentes/ui/Section';
import MiDataTableRunciccfg from './MiDataTableRunciccfg';
import MiDataTableVerLineas from './MiDataTableVerLineas';
import MiSelect from '../../componentes/formulario/MiSelect';
import Button from '../../componentes/ui/Button';
import MiSelectMultiple from '../../componentes/formulario/MiSelectMultiple';
import { Alert } from '../../componentes/ui/Alert';
import { alertService } from '../../services/alertservice';
import Uplm from '../../componentes/formulario/Uplm/Uplm';
import Upls from '../../componentes/formulario/Upls/Upls';
import PermissionRefused from '../../componentes/ui/PermissionRefused';
import LoadingPage from '../../componentes/ui/LoadingPage';
import ListaRel from '../../componentes/formulario/ListaRel/ListaRel';
import Informes from '../../componentes/formulario/informes/Informes';
import Modal from 'react-bootstrap/Modal';
import InformesBtn from '../../componentes/formulario/informes/informesBtn/InformesBtn';
import MiDataTable from '../../componentes/ui/MiDataTable';
import CheckIos from '../../componentes/ui/CheckIos';



import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Spinner from 'react-bootstrap/Spinner';
import SpinnerFloat from '../../componentes/ui/SpinnerFloat';

import useLogicForm from '../../hooks/useLogicForm';

import Cookies from 'universal-cookie';

import { Fragment } from 'react';

import { getApiUrl, axiosPost, dateFormatByLocale, getTitle, getDecodedCookie, renderTabTitle, encryptData, MiReplaceAll } from '../../helpers/helperApp';




let varAccion = null;
let backUpOptionsUbi;
let varOrigen = "";
let lineaSelect;

function RunCicCfg(props){

    const cookies = new Cookies();
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    // ***** Custom Hook - Lógica de los formularios *****
    const { registrosPrin, saveRegistrosPrin, formularioPrin, saveFormularioPrin, adjuntosPrin, saveAdjuntosPrin, adjuntosExistentesPrin, saveAdjuntosExistentesPrin, registrosHijo,  formularioHijo, saveFormularioHijo, adjuntosHijo, saveAdjuntosHijo, adjuntosExistentesHijo, saveAdjuntosExistentesHijo, handleInputForm, handleLastReg, handleEditRegPrin, loadingTable, saveLoadingTable, loadReg, regIniciales, handleEditRegHijo, handleDeleteItemPrin, handleDeleteItemHijo, handleSubmitPrin, handleSubmitHijo, resetFormPrin, resetFormHijo, handleSelectFormPrin, handleSelectMultipleFormPrin } = useLogicForm();

    // ***** Context *****
    const { validateSesion, socket, confApp, saveConfApp, getConfApp, apiKey, logo, appCryptCom, cicDefAge } = useContext(LoginContext);    

    // ***** State para la configuración de la pantalla *****
    const [ confPantalla, saveConfPantalla ] = useState(confApp)
    const [ loadedConf, saveLoadedConf ] = useState(false);
    const [ tieneNivel, saveTieneNivel ] = useState(true);
    const [ idCiclo, saveIdCiclo ] = useState("");
    const [ loadingCiclo, saveLoadingCiclo ] = useState(true);
    const [ ciclo, saveCiclo ] = useState([]);
    const [ showModal, saveShowModal ] = useState(false);
    const [ idNuevoCiclo, saveIdNuevoCiclo ] = useState(0);
    const [ loadingNuevoCiclo, saveLoadingNuevoCiclo ] = useState(false);
    const [ numSteps, saveNumSteps ] = useState([]);
    const [ titleTabs, saveTitleTabs ] = useState([]);
    const [ forceBtnNext, saveForceBtnNext ] = useState(0);
    const [ stepBtnNext, saveStepBtnNext ] = useState();
    const [ showModalNextStep, saveShowModalNextStep ] = useState(false);
    const [ loadingModalNextStep, saveLoadingModalNextStep ] = useState(false);
    const [ infoModalNextStep, saveInfoModalNextStep ] = useState({opt: 0, divi: 0, apl: 0});
    const [ tablaModalNextStep, saveTablaModalNextStep ] = useState();
    const [ txtModalDocs, saveTxtModalDocs ] = useState();

    const [ registrosSeleccionados, saveRegistrosSeleccionados ] = useState([]); 
    const [ datosTablas, saveDatosTablas ] = useState([]);
    const [ cantidadEdi, saveCantidadEdi ] = useState([]);
    const [ ubicacionesEdi, saveUbicacionesEdi ] = useState([]);
    const [ revisadoEdi, saveRevisadoEdi ] = useState([]);
    const [ showModalLineas, saveShowModalLineas ] = useState(false); 
    const [ tablaLineas, saveTablaLineas ] = useState([]);
    const [ loadingTablaLineas, saveLoadingTablaLineas ] = useState(false);
    const [ renderedTitleTabs, saveRenderedTitleTabs ] = useState([]);
    const [ pasoTablaVerLineas, savePasoTablaVerLineas ] = useState(null);
    const [ showModalResponsable, saveShowModalResponsable ] = useState(false);
    const [ valResponsable, saveValResponsable ] = useState(0);
    const [ idDocUpdateResponsable, saveIdDocUpdateResponsable ] = useState(0);
    const [ loadingUpdateResponsable, saveLoadingUpdateResponsable ] = useState(false);
    const [ showModalInfoOperacion, saveShowModalInfoOperacion ] = useState(false);    
    const [ datosTablaInfoOperacion, saveDatosTablaInfoOperacion ] = useState([]);
    const [ loadingTablaInfoOperacion, saveLoadingTablaInfoOperacion ] = useState([]);
    const [ codCic, saveCodCic ] = useState("");
    const [ infoCiclo, saveInfoCiclo ] = useState([]);
    const [ optionsUbi, saveOptionsUbi ] = useState(null);
    const [ loadedSelect, saveLoadedSelect ] = useState(false);
    const [ valModalResponsable, saveValModalResponsable ] = useState(0);
    const [ valModalCentro, saveValModalCentro ] = useState(0);
    const [ valModalDescripcion, saveValModalDescripcion ] = useState("");
    const [ valModalIncludeCero, saveValModalIncludeCero ] = useState(false);
    const [ idDocInformesModalNextStep, saveIdDocInformesModalNextStep ] = useState(0);  


    useEffect( () => {        
        
        // ***** Validamos que el usuario esté logueado sino lo enviamos al login*****
        validateSesion(props)
            .then( (respuesta) => {
                if( confPantalla === undefined ){
                    return getConfApp();
                }else{                             
                    document.title = getTitle(confPantalla.config.trad, confPantalla.runciccfg.title);                               
                    if( respuesta == 1 ){
                        saveTieneNivel(true);
                        saveLoadingCiclo(false)
                        if( props.location.state ){                                                                              
                            if( "idCic" in props.location.state && "idDoc" in props.location.state && "idCen" in props.location.state && "idAge2" in props.location.state ){
                                // Crear y seleccionar
                                varOrigen = props.location.state.origen;
                                autoIniciar(props.location.state.idCic, props.location.state.idDoc, props.location.state.idCen, props.location.state.idAge2, props.location.state.nom1, props.location.state.includecero, props.location.state.origen);
                            }else if( "idDoc" in props.location.state ){
                                // Seleccionar                                
                               autoIniciarFull(props.location.state.idDoc);
                            }                        
                        }
                    }
                    else if( respuesta == 0 ){
                        saveTieneNivel(false);
                    }                    
                    saveLoadedConf(true);        
                }
            })
            .then( (respuesta) => {
                if( respuesta !== undefined  ){
                    saveConfPantalla(respuesta.msg);
                    saveConfApp(respuesta.msg);             
                }
            })            

        // Liberamos todos los registros al salir de la pantalla
        return () =>{
            if( socket != null ){
                socket.emit("salirPantalla", { "idciccfg": getDecodedCookie('id'), "tabla": "undefined" })
            }
            document.querySelector("body").classList.remove("sidebar-open");
            // Token cancelación axios al desmontar componentes
            source.cancel();    
        }         
        
    },[confPantalla])

    const autoIniciar = async (idCicloParam, idDocParam, idCenParam, idAge2Param, nom1Param, includeCeroParam, origenParam) => {
        await loadOptionsCbo(confPantalla.runciccfg.padre.datatablemodallineas.ubi.datatype, confPantalla.runciccfg.padre.datatablemodallineas.ubi.data, optionsUbi, saveOptionsUbi);

        saveLoadingNuevoCiclo(true);    

        saveIdCiclo(idCicloParam);
        await getCicloEnCurso(idCicloParam);                
        const idAutoSelect = await nuevoCiclo(idCicloParam, idDocParam, idCenParam, idAge2Param, MiReplaceAll(nom1Param, "||", "/"), includeCeroParam, origenParam); 
        await getCicloEnCurso(idCicloParam, idAutoSelect);  

        // Seleccionar
        let auxRegistrosSeleccionados = [];        
        const datosAux = { ["runciccfgTab_1"] : `#row-${idAutoSelect}` };
        auxRegistrosSeleccionados.push(datosAux);
        saveRegistrosSeleccionados(auxRegistrosSeleccionados)         
        
        await autoIniciarFull(idAutoSelect, auxRegistrosSeleccionados, false, true);

        saveLoadingNuevoCiclo(false);
        saveLoadingCiclo(false);    
    }

    const autoIniciarFull = async (idDoc, auxRegistrosSeleccionadosParam=null, returnData=false, fromAutoIniciar=false) =>{        
        saveLoadingNuevoCiclo(true);

        if(fromAutoIniciar == false || fromAutoIniciar == null){
            await loadOptionsCbo(confPantalla.runciccfg.padre.datatablemodallineas.ubi.datatype, confPantalla.runciccfg.padre.datatablemodallineas.ubi.data, optionsUbi, saveOptionsUbi);
        }

        // Obtener todos los ids de documentos del ciclo, sus paso ordenados y el id del ciclo para el siguiente paso, getciclo
        const data = new FormData();      
        data.append("validacion", apiKey());
        data.append("iddoc", idDoc);
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.runciccfg.padre.getalldocsciclo, data, source.token);        
        if( typeof respuesta.data == "string"){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});
            return; 
        }    

        let auxDatosTablas = []; 
        let auxRegistrosSeleccionados = [];
        saveInfoCiclo(respuesta.data);         
        if(respuesta.data.length > 0){            
            saveIdCiclo(respuesta.data[0].idcic);
            saveCodCic(respuesta.data[0].codcic);            
            const docIniCiclo = respuesta.data[0].idori;
           
            // Obtnemos el ciclo para el select y la info de los tabs
            await getCicloEnCurso(respuesta.data[0].idcic, idDoc);

            // Obtnemos los datos de las tablas            
            if(auxRegistrosSeleccionadosParam != null){
                auxRegistrosSeleccionados = auxRegistrosSeleccionadosParam;
            }
             
            // Tabla primer paso
            const auxDatosTableFirst = await getDatosTable(respuesta.data[0].idcic, true);
            if(auxDatosTableFirst.length > 0){
                auxDatosTablas.push(auxDatosTableFirst);
                if(!auxRegistrosSeleccionados.some(obj => obj.hasOwnProperty('runciccfgTab_1'))){
                    auxRegistrosSeleccionados.push({ [`runciccfgTab_1`] : `#row-${docIniCiclo}` });
                }
            }
            
            // Resto de tablas           
            let numPasos;
            for (let i = 0; i < respuesta.data.length; i++) {
                if (respuesta.data[i].iddoc != 0) {
                    numPasos = respuesta.data[i].ord;                    
                }
            }
            let pasosNext = [];                                  
            for(let i=1; i < numPasos; i++){
                    pasosNext.push(i);
            }            
            const dataTableNext = await getDatosTableNextStep(respuesta.data[0].idcic, null, auxRegistrosSeleccionados, pasosNext);            
            for(let i=0; i < dataTableNext.length; i++){                                          
                auxDatosTablas.push(dataTableNext[i]);
                if(!auxRegistrosSeleccionados.some(obj => obj.hasOwnProperty(`runciccfgTab_${i+2}`))){
                    auxRegistrosSeleccionados.push({ [`runciccfgTab_${i+2}`] : `#row-${dataTableNext[i][0].id}` });
                }                                                            
            }

            // Seleccionamos el que llegar por parámetro
            let numTab = 0;
            for(let x=0; x<respuesta.data.length; x++){                    
                if(respuesta.data[x].iddoc == idDoc){
                    numTab = respuesta.data[x].ord;
                    auxRegistrosSeleccionados[respuesta.data[x].ord-1][`runciccfgTab_${respuesta.data[x].ord}`] = `#row-${idDoc}`;                                   
                }
            }
                        
            saveRegistrosSeleccionados(auxRegistrosSeleccionados);
            saveDatosTablas(auxDatosTablas);

            // Ir al tab del documento que llegó por parámetro
            const linkTab = document.getElementById(`tab1-tab-tab_${numTab}`);            
            if(linkTab){
                linkTab.click();
            }            
        }

        saveLoadingNuevoCiclo(false);
        if(returnData){
            return [auxDatosTablas, auxRegistrosSeleccionados];
        }
    }

    const handleSelect= (selectedItem, nameOfComponent, saveData, setDescripcion=false) => {        
        if( selectedItem ){
            saveData(selectedItem.value)
            if(setDescripcion == true){                
                saveValModalDescripcion(selectedItem.labelnohtml); 
            }
        }else{
            saveData(0)
            if(setDescripcion == true){                
                saveValModalDescripcion(""); 
            }
        }
    }
    
    const handleSelectCiclo = async (selectedItem, nameOfComponent) => {

        if( selectedItem ){
            await getCicloEnCurso(selectedItem.value);
            await getDatosTable(selectedItem.value);
            saveIdCiclo(selectedItem.value);
        }else{
            saveIdCiclo("")
            saveCiclo([])
            saveRegistrosSeleccionados([])
            saveDatosTablas([])            
        }
    }

    const handleSelectResponsable = (selectedItem, nameOfComponent) => {
        if( selectedItem ){
            saveValResponsable(selectedItem.value) 
        }else{
            saveValResponsable(0)
        }
    }

    const showModalFn = () => {
        saveShowModal(true);
        saveIdNuevoCiclo(0);
        saveValModalCentro(0);
        saveValModalResponsable(cicDefAge);
        saveValModalDescripcion("");
        saveValModalIncludeCero(false);
    }
    
    const getCicloEnCurso = async (idCiclo, idAutoSelect=null) => {    

        saveLoadingCiclo(true);
        saveCiclo([]);
        
        const data = new FormData();      
        data.append("validacion", apiKey());
        data.append("idciclo", idCiclo);
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.runciccfg.padre.getciclo, data, source.token);
        if( typeof respuesta.data == "string"){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true}); 
        }else{            
            saveNumSteps(getLengthCiclo(respuesta.data.ciclo[0].numsteps));
            saveCiclo(respuesta.data.ciclo[0]);
            saveTitleTabs(respuesta.data.titletabs);              
            saveRenderedTitleTabs(await renderTabTitle(respuesta.data.titletabs, respuesta.data.titletabs.length, idAutoSelect));         
        }
        saveLoadingCiclo(false);

    }

    const getLengthCiclo = (steps) => {
        let data = [];
        for(let i=0; i<steps; i++){
            data.push(i);
        }
        return data;
    }

    const getDatosTable = async (idCiclo, forceReturn=false) => {            
        saveLoadingCiclo(true);
        saveDatosTablas([]);       
        
        const data = new FormData();      
        data.append("validacion", apiKey());
        data.append("idciclo", idCiclo);
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.runciccfg.padre.getdatostable, data, source.token);

        if( typeof respuesta.data == "string"){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true}); 
        }else{            
            saveDatosTablas(datosTablas => [...datosTablas, respuesta.data])
            if(forceReturn){
                saveLoadingCiclo(false);
                return respuesta.data;
            }
        }
        saveLoadingCiclo(false);

    }

    const nuevoCiclo = async (idCicloParam=null, idNuevoCicloParam=null, idCenParam=null, idAge2Param=null, nom1Param=null, includeCeroParam=null, origen=null) => {            
        if(idCicloParam != null) saveLoadingCiclo(true);  
        saveLoadingNuevoCiclo(true);
        const data = new FormData();      
        data.append("validacion", apiKey());
        data.append("idciclo", idCicloParam != null ? idCicloParam : idCiclo);
        data.append("idnuevociclo", idNuevoCicloParam != null ? idNuevoCicloParam: idNuevoCiclo);        
        data.append("idage2", idAge2Param != null ? idAge2Param : valModalResponsable);
        data.append("idcen", idCenParam != null ? idCenParam : valModalCentro);
        data.append("nom1", nom1Param != null ? nom1Param : valModalDescripcion);
        data.append("includecero", includeCeroParam != null ? includeCeroParam : valModalIncludeCero);
        data.append("origenciclo", origen);
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.runciccfg.padre.createInitCiclo.getdata, data, source.token);
        saveShowModal(false);

        if( typeof respuesta.data == "string"){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true}); 
            saveLoadingNuevoCiclo(false);
            return 0;
        }else{
            if(respuesta.data.showSuccess == true){
                alertService.success(`<i class="fal fa-times-octagon mr-1"></i>${confPantalla.runciccfg.padre.createInitCiclo.success.title}`, {autoClose: true});
            }
            if(idCicloParam == null){
                await getDatosTable(idCiclo);
                const auxRegistrosSeleccionados = [{ ["runciccfgTab_1"]: `#row-${respuesta.data.id}` }];
                saveRegistrosSeleccionados(auxRegistrosSeleccionados); 
                await autoIniciarFull(respuesta.data.id, auxRegistrosSeleccionados, false, false);
                saveLoadingNuevoCiclo(false);          
            }            
            saveIdCiclo(idCicloParam != null ? idCicloParam : idCiclo)            
            saveRenderedTitleTabs(await renderTabTitle(titleTabs, titleTabs.length, respuesta.data.id)); 
            saveLoadingNuevoCiclo(false);
            return respuesta.data.id;    
        }
    }

    const getHeaderModalNextStep = () => {        
        const info = $(".runciccfgTab_"+stepBtnNext).DataTable().rows( { selected: true } ).data()[0];
        let txtEquipo = "";
        let txtDesc = "";
        if(info && info.length > 0){
            txtEquipo = info.equitab != "" && info.equitab ? info.equitab+" - " : "";
            txtDesc = info.descripcion;
        }
        const h5 = <div className="col-12">
                   {/* <div className="col-md-10 offset-1" > */}
                        <div className="alert alert-secondary alertHelp text-center" role="alert" style={{margin: "0px"}}>
                            <div className="flex-center">
                                <div className="col-2" style={{display: "flex", justifyContent: "left"}}>
                                    <h5 style={{marginBottom : "0px"}}>
                                        {confPantalla.runciccfg.padre.helpmodal.pasoactual.title} {stepBtnNext}/{numSteps.length}:                                  
                                        <span dangerouslySetInnerHTML={{ __html: txtEquipo+txtDesc }} />
                                    </h5>
                                </div>
                                <div className="col-8" style={{display: "flex", justifyContent: "center"}}>
                                    {getTxtHelp(null, null, null, null, true, false)}
                                </div>
                                <div className="col-2" style={{display: "flex", justifyContent: "right"}}>
                                    <p 
                                        className={ infoModalNextStep.opt == 0 ? "text-danger text-center mr-2"  : "text-success text-center mr-2" } 
                                        style={{marginBottom : "0px"}}>
                                        {confPantalla.runciccfg.padre.helpmodal.opcional.title}
                                        {/* {
                                            infoModalNextStep.opt == 0 
                                            ? <i className="ml-1 fal fa-square" style={{fontSize : "1.2em"}}></i>
                                            : <i className="ml-1 fal fa-check-square" style={{fontSize : "1.2em"}}></i>
                                        } */}
                                    </p>
                                    <p 
                                        className={ infoModalNextStep.divi == 0 ? "text-danger text-center mr-2"  : "text-success text-center mr-2" } 
                                        style={{marginBottom : "0px"}}>
                                        {confPantalla.runciccfg.padre.helpmodal.divisible.title}
                                        {/* {
                                            infoModalNextStep.divi == 0 
                                            ? <i className="ml-1 fal fa-square" style={{fontSize : "1.2em"}}></i>
                                            : <i className="ml-1 fal fa-check-square" style={{fontSize : "1.2em"}}></i>
                                        } */}
                                    </p>
                                    <p 
                                        className={ infoModalNextStep.apl == 0 ? "text-danger text-center mr-2"  : "text-success text-center mr-2" } 
                                        style={{marginBottom : "0px"}}>
                                        {confPantalla.runciccfg.padre.helpmodal.apilable.title}
                                        {/* {
                                            infoModalNextStep.apl == 0 
                                            ? <i className="ml-1 fal fa-square" style={{fontSize : "1.2em"}}></i>
                                            : <i className="ml-1 fal fa-check-square" style={{fontSize : "1.2em"}}></i>
                                        } */}
                                    </p>
                                </div>
                            </div>
                            
                            {/* <div className="col-md-12 col-lg-2">
                                <div className={infoModalNextStep.apl == 0 ? "alert alert-danger alertHelp text-center"  : "alert alert-success alertHelp text-center"} role="alert">
                                    <h5 style={{marginBottom : "0px"}}>
                                        {confPantalla.runciccfg.padre.helpmodal.apilable.title}
                                        {
                                            infoModalNextStep.apl == 0 
                                            ? <i className="ml-1 fal fa-square" style={{fontSize : "1.2em"}}></i>
                                            : <i className="ml-1 fal fa-check-square" style={{fontSize : "1.2em"}}></i>
                                        }
                                    </h5>
                                </div>
                            </div>  */}


                        </div>
                    </div>;
        return h5;
    }

    const getTxtHelp = (idRow, id, datos, selectedRows, getSelected=false, returnAlert=true) =>{                 
        if(getSelected){
            let help = null;
            selectedRows = $('#tableModalDocs').DataTable().rows( { selected: true } ).data();
            let txtEquipo = "";
            let txtDesc = "";
            if(selectedRows.length > 0){
                txtEquipo = selectedRows[0]["equitab"] != "" && selectedRows[0]["equitab"] ? selectedRows[0]["equitab"]+" - " : "";
                txtDesc = selectedRows[0]["descripcion"];
            }

            if(returnAlert == true){
                selectedRows.length == 0 
                ?
                    help =  <div className="alert alert-success mt-1" role="alert" style={{width : "fit-content"}}>
                                <h5 style={{marginBottom : "0px"}}>{confPantalla.runciccfg.padre.helpmodal.crear.title}</h5>
                            </div>
                :
                    help = <div className="alert alert-primary mt-1" role="alert" style={{width : "fit-content"}}>
                                <h5 style={{marginBottom : "0px"}}>{confPantalla.runciccfg.padre.helpmodal.editar.title+" "}                                
                                    <span style={{fontWeight: "700"}} dangerouslySetInnerHTML={{ __html: txtEquipo+txtDesc }} />
                                </h5>
                            </div>
                return help;
            }else{
                selectedRows.length == 0 
                ?
                    help = <h5 className="text-success " >{confPantalla.runciccfg.padre.helpmodal.crear.title}</h5>
                :
                    help = <h5 className="text-primary " >{confPantalla.runciccfg.padre.helpmodal.editar.title+" "}
                                <span style={{fontWeight: "700"}} dangerouslySetInnerHTML={{ __html: txtEquipo+txtDesc }} />
                           </h5>
                           
                return help;
            }
        }else{
            let txtEquipo = "";
            let txtDesc = "";
            if(selectedRows.length > 0){
                txtEquipo = selectedRows[0]["equitab"] != "" && selectedRows[0]["equitab"] ? selectedRows[0]["equitab"]+" - " : "";
                txtDesc = selectedRows[0]["descripcion"];
            }
            saveTxtModalDocs(selectedRows.length == 0 
                            ?                             
                                <div className="alert alert-success mt-1" role="alert" style={{width : "fit-content"}}>
                                    <h5 style={{marginBottom : "0px"}}>{confPantalla.runciccfg.padre.helpmodal.crear.title}</h5>
                                </div>  
                            : 
                                <div className="alert alert-primary mt-1" role="alert" style={{width : "fit-content"}}>
                                    <h5 style={{marginBottom : "0px"}}>{confPantalla.runciccfg.padre.helpmodal.editar.title+" "}
                                        <span style={{fontWeight: "700"}} dangerouslySetInnerHTML={{ __html: txtEquipo+txtDesc }} />
                                    </h5>
                                </div>                                                    
                            )
        }

    }
    
    const nextStep = async (step, defaultAgeNextStep) => {        
        saveStepBtnNext(step);        
        saveCantidadEdi([]); // Reiniciamos el array que donde almacenamos los valores cuando editamos la cantidad en el modal
        saveUbicacionesEdi([]);
        saveRevisadoEdi([]);
        saveValResponsable(defaultAgeNextStep);
        if(numSteps.length == step ){  
            // Finalizar ciclo
            saveLoadingCiclo(true);

            const aux = datosTablas;
            saveDatosTablas([]); 

            const idDoc = registrosSeleccionados.filter((reg) => Object.keys(reg)[0] == "runciccfgTab_"+step)[0]["runciccfgTab_"+step].split("-")[1];            
            
            const data = new FormData();      
            data.append("validacion", apiKey());
            data.append("iddoc", idDoc);               
            const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.runciccfg.padre.finalizarciclo, data, source.token);
                        
            if( typeof respuesta.data == "string"){
                alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});                 
            }else{                
                // Volver a carga la tabla actual
                const dataTableActual = await getDatosTableNextStep(idCiclo, step-1, registrosSeleccionados);
                aux[step-1] = dataTableActual;  
                saveDatosTablas(aux);    
            }
            saveLoadingCiclo(false);

        }else{                    
            saveLoadingModalNextStep(true);
            saveTablaModalNextStep([]);
            saveInfoModalNextStep({opt: 0, divi: 0, apl: 0});
            getTxtHelp(null, null, null, [])
            const idDoc = registrosSeleccionados.filter((reg) => Object.keys(reg)[0] == "runciccfgTab_"+step)[0]["runciccfgTab_"+step].split("-")[1];
            
            saveIdDocInformesModalNextStep(idDoc);
            const data = new FormData();      
            data.append("validacion", apiKey());
            data.append("step", step+1);
            data.append("iddoc", idDoc);
            data.append("idciclo", idCiclo);
    
            // Obtenemos la configuración(DIVISIBLE, APILABLE, OPCIONAL)
            const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.runciccfg.padre.getinfomodalnextstep, data, source.token);       
            if( typeof respuesta.data == "string"){
                alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true}); 
            }else{
                saveInfoModalNextStep(respuesta.data[0]);
                
                // Acciones según su configuración(DIVISIBLE, APILABLE, OPCIONAL)
                await actionsByConf(respuesta.data[0].opt, respuesta.data[0].divi, respuesta.data[0].apl, step);                                     
            }
            
            saveLoadingModalNextStep(false);
        }
    }

    const actionsByConf = async (opcional, divisible, apilable, paso) => {  

        // Opcional sacarlo tratarlo aparte. Si es opcional me salto
        switch (divisible + '' + apilable) {
            case '00':  // NO divisible, NO apilable
                            // Consultamos si hay documentos en la tabla siguiente, si hay quiere decir que existe un paso sino creamos el documento del siguiente paso
                            const existeDocSiguiente = $(".runciccfgTab_"+(paso+1)).DataTable().rows().data();
                            if(existeDocSiguiente.length > 0){
                                alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${confPantalla.runciccfg.padre.existedoc.title}`, {autoClose: false});
                            }else{
                                // Creamos el documento siguiente
                                okNextStepModal(null, paso, false);
                            }
              break;
            case '01':  // NO divisible, SI apilable
                            // Creamos el documento siguiente independientemente de si hay documento o no
                            okNextStepModal(null, paso, false);                    
              break;
            case '10':  // SI divisible, NO apilable
                            // Nos traemos las lineas, para la tabla de lineas del modal, que NO aparezcan en documentos del siguiente paso
                            const dataTableLineasModal = await getTablaModalLineas(idCiclo, paso, registrosSeleccionados, true); 
                            if(dataTableLineasModal.length == 0){
                                alertService.warn(`<i class="fal fa-times-octagon mr-1"></i>${confPantalla.runciccfg.padre.nolineaspendientesenpaso.title}`, {autoClose: false});
                                // Ir al tab del documento que llegó por parámetro
                                const linkTab = document.getElementById(`tab1-tab-tab_${paso+1}`);            
                                if(linkTab){
                                    linkTab.click();
                                } 
                            }else{
                                saveShowModalNextStep(true);
                                saveTablaModalNextStep(dataTableLineasModal);                                
                            }                           
              break;
            case '11':  // SI divisible, SI apilable
                            // Nos traemos TODAS las lineas, para la tabla de lineas del modal
                            const dataTableLineasModalDiviApl = await getTablaModalLineas(idCiclo, paso, registrosSeleccionados, false);                            
                            if(dataTableLineasModalDiviApl.length == 0){
                                alertService.warn(`<i class="fal fa-times-octagon mr-1"></i>${confPantalla.runciccfg.padre.nolineaspendientesenpaso.title}`, {autoClose: false});
                                // Ir al tab del documento que llegó por parámetro
                                const linkTab = document.getElementById(`tab1-tab-tab_${paso+1}`);            
                                if(linkTab){
                                    linkTab.click();
                                } 
                            }else{
                                saveShowModalNextStep(true);
                                saveTablaModalNextStep(dataTableLineasModalDiviApl);                                
                            } 
              break;            
          }

    }
    
    const okNextStepModal = async (e, pasoNext=null, showModal=null) => {            
        let continuar = true;
        let idActualizar = null;
        let selectedLines = null;
        let docActualizar = null;
        let auxSelectedLines = [];
        let filtrarLineas;
        let cerrarModal = true;        
        if( ((infoModalNextStep.divi == "1" && infoModalNextStep.apl == "0") || (infoModalNextStep.divi == "1" && infoModalNextStep.apl == "1")) && showModal == null ){
            selectedLines = $('#tableModalLineas').DataTable().rows( { selected: true } ).data();
            if( selectedLines.length == 0 ){
                alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${confPantalla.runciccfg.padre.selectlineas.title}`, {autoClose: true})
                continuar = false;
            }else{
                docActualizar = $('#tableModalDocs').DataTable().rows( { selected: true } ).data();
                docActualizar.length > 0 ? idActualizar = docActualizar[0].id : idActualizar = null;
                for(let i=0; i<selectedLines.length; i++){
                    auxSelectedLines.push(selectedLines[i].id)
                }                
            }
            if( infoModalNextStep.divi == "1" && infoModalNextStep.apl == "0" ){
                // SI divisible, NO apilable - Crear o modificar documento con las lineas seleccionadas y eliminarlas del selector de lineas del modal
                filtrarLineas = true;
            }else if(infoModalNextStep.divi == "1" && infoModalNextStep.apl == "1"){
                // SI divisible, SI apilable - Crear o modificar documento con las lineas seleccionadas
                filtrarLineas = false;
            }
            cerrarModal = false;
        }

        if(continuar){
            // Crear el documento correspondiente
            saveLoadingCiclo(true);            
            !pasoNext ? pasoNext = stepBtnNext : pasoNext = pasoNext;
            
            const idClonar = registrosSeleccionados.filter((reg) => Object.keys(reg)[0] == "runciccfgTab_"+pasoNext)[0]["runciccfgTab_"+pasoNext].split("-")[1];            
            if(showModal == false){
                varAccion = 3;
            }else{
                if(idActualizar == null){
                    varAccion = 4;
                }else{
                    varAccion = 5;
                }
            }
        
            const data = new FormData();      
            data.append("validacion", apiKey());
            data.append("idciclo", idCiclo);
            data.append("idclonar", idClonar);
            data.append("step", pasoNext);
            data.append("showmodal", showModal);
            data.append("cantidades", JSON.stringify(filterCantidadEdi(cantidadEdi, auxSelectedLines)));
            data.append("ubicaciones", JSON.stringify(filterUbicacionesEdi(ubicacionesEdi, auxSelectedLines)));
            data.append("idage2", valResponsable);
            if(idActualizar){
                data.append("idactualizar", idActualizar);
            }
            if(selectedLines){
                data.append("selectedlines", JSON.stringify(auxSelectedLines));
            }
            const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.runciccfg.padre.createnextdoc, data, source.token);
            saveShowModal(false);
    
            if( typeof respuesta.data == "string"){
                alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true}); 
                return;
            }else{
                alertService.success(`<i class="fal fa-times-octagon mr-1"></i>${confPantalla.runciccfg.padre.createInitCiclo.success.title}`, {autoClose: true});
                saveIdDocUpdateResponsable(respuesta.data.iddoc);
                // saveValResponsable(respuesta.data.idage2);               
                saveRenderedTitleTabs(await renderTabTitle(titleTabs, titleTabs.length, respuesta.data.iddoc));  
            }            
                 
            const aux = datosTablas;
            if(pasoNext == 1){
                // Tabla primer paso                
                const auxDatosTableFirst = await getDatosTable(idCiclo, true);
                aux[0] = auxDatosTableFirst; 
                
            }else if(pasoNext > 1){
                 // Volver a carga la tabla actual
                const dataTableActual = await getDatosTableNextStep(idCiclo, pasoNext-1, registrosSeleccionados);
                aux[pasoNext-1] = dataTableActual;                
            }

            // Volver a cargar la tabla siguiente(LA QUE CONTIENE EL DOCUMENTO QUE ACABAMOS DE CREAR)            
            const dataTableNext = await getDatosTableNextStep(idCiclo, pasoNext, registrosSeleccionados);            
            aux[pasoNext] = dataTableNext;
            saveDatosTablas(aux);
                       
            if(cerrarModal){
                saveShowModalNextStep(false);
            }else{
                if(filtrarLineas){
                    const dataTableLineasModal = await getTablaModalLineas(idCiclo, stepBtnNext, registrosSeleccionados, true);
                    saveTablaModalNextStep(dataTableLineasModal);
                }else{
                    const dataTableLineasModalDiviApl = await getTablaModalLineas(idCiclo, stepBtnNext, registrosSeleccionados, false);
                    saveTablaModalNextStep(dataTableLineasModalDiviApl);
                }
                
            }

            let auxRegistrosSeleccionados = [...registrosSeleccionados];                 
            if(auxRegistrosSeleccionados.length > 0){                
                const clave = "runciccfgTab_" + (pasoNext + 1);
                const valor = `#row-${respuesta.data.iddoc}`;

                // Buscar si ya existe un objeto con esa clave
                const index = auxRegistrosSeleccionados.findIndex(
                    reg => Object.keys(reg)[0] === clave
                );

                if (index !== -1) {
                    // Ya existe → editar
                    auxRegistrosSeleccionados[index][clave] = valor;
                } else {
                    // No existe → añadir
                    auxRegistrosSeleccionados.push({ [clave]: valor });
                }                

            }             
            saveRegistrosSeleccionados(auxRegistrosSeleccionados);
            
            saveLoadingCiclo(false);
            
            saveForceBtnNext(forceBtnNext => forceBtnNext+1);

            // 29-01-25 Cerramos siempre el modal de divisible, apilable
            saveShowModalNextStep(false);
            if(showModal == false){
                saveShowModalResponsable(true);
            }
        }

    }

    const guardadoProvisional = async (e) =>{

        saveLoadingCiclo(true);

        const data = new FormData();      
        data.append("validacion", apiKey());        
        data.append("cantidades", JSON.stringify(cantidadEdi));
        data.append("ubicaciones", JSON.stringify(ubicacionesEdi));
        data.append("revisado", JSON.stringify(revisadoEdi));
        
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+"/runciccfg/guardadoProvisional", data, source.token);        

        if( typeof respuesta.data == "string"){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true}); 
            return;
        }else{
            alertService.success(`<i class="fal fa-times-octagon mr-1"></i>${confPantalla.runciccfg.padre.guardadoprovisional.title}`, {autoClose: true});            
        }  

        saveLoadingCiclo(false);
        saveShowModalNextStep(false);
    }

    const updateResponsable = async () => {       
        saveLoadingUpdateResponsable(true);        

        const data = new FormData();      
        data.append("validacion", apiKey());
        data.append("iddoc", idDocUpdateResponsable);
        data.append("idage2", valResponsable);
        data.append("step", stepBtnNext);
        data.append("accion", varAccion);        
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.runciccfg.padre.modalresponsable.updateresponsable, data, source.token);

        if( typeof respuesta.data == "string"){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true}); 
            saveLoadingUpdateResponsable(false);
            saveShowModalResponsable(false);
            return;
        }

        const aux = datosTablas;
        if(stepBtnNext == 1){
            // Tabla primer paso                
            const auxDatosTableFirst = await getDatosTable(idCiclo, true);
            aux[0] = auxDatosTableFirst; 
            
        }else if(stepBtnNext > 1){
            // Volver a carga la tabla actual
            const dataTableActual = await getDatosTableNextStep(idCiclo, stepBtnNext-1, registrosSeleccionados);
            aux[stepBtnNext-1] = dataTableActual;                
        }
       
        // Volver a cargar la tabla siguiente(LA QUE CONTIENE EL DOCUMENTO QUE ACABAMOS DE CREAR)        
        const dataTableNext = await getDatosTableNextStep(idCiclo, stepBtnNext, registrosSeleccionados);                
        aux[stepBtnNext] = dataTableNext;
        saveDatosTablas(aux);        
        let auxRegistrosSeleccionados = [...registrosSeleccionados];                 
            if(auxRegistrosSeleccionados.length > 0){                
                const clave = "runciccfgTab_" + (stepBtnNext + 1);
                const valor = `#row-${respuesta.data.iddoc}`;

                // Buscar si ya existe un objeto con esa clave
                const index = auxRegistrosSeleccionados.findIndex(
                    reg => Object.keys(reg)[0] === clave
                );

                if (index !== -1) {
                    // Ya existe → editar
                    auxRegistrosSeleccionados[index][clave] = valor;
                } else {
                    // No existe → añadir
                    auxRegistrosSeleccionados.push({ [clave]: valor });
                }
            }                                
        saveRegistrosSeleccionados(auxRegistrosSeleccionados);
        
        saveLoadingUpdateResponsable(false);
        saveShowModalResponsable(false);
    }

    const filterCantidadEdi = (cantidadEdi, auxSelectedLines) => {
        let data = [];
        data = cantidadEdi.filter((reg, index) => {            
            if(auxSelectedLines.includes(reg.idLin)){
                reg.cant == ''? reg.cant = 0: reg.cant = reg.cant;
                return reg;
            }
        })
        return data;
    }

    const filterUbicacionesEdi = (ubicacionesEdi, auxSelectedLines) => {        
        let data = [];
        data = ubicacionesEdi.filter((reg, index) => {            
            if(auxSelectedLines.includes(reg.idLin)){
                reg.idubi == ''? reg.idubi = 0: reg.idubi = reg.idubi;
                return reg;
            }
        })
        return data;
    }

    const getDatosTableNextStep = async (idCiclo, step, regSeleccionados, steps=null) => { 

        let datosTabla = [];
        saveLoadingCiclo(true);        

        let appendStep = [];
        let idsClonar = [];
        let idClonar;        
                    
        if(steps != null){
            // Varios pasos. Se ejecuta al seleccionar el primer paso
            idClonar = regSeleccionados.filter((reg) => Object.keys(reg)[0] == "runciccfgTab_1")[0]["runciccfgTab_1"].split("-")[1];            
            appendStep = steps;
        }else{
            // Un único paso. Se ejecuta tras okmodalstep y tras actualizar el responsable.
            idClonar = regSeleccionados.filter((reg) => Object.keys(reg)[0] == "runciccfgTab_"+step)[0]["runciccfgTab_"+step].split("-")[1];            
            appendStep.push(step);            
        }

        for(let i = 0; i < appendStep.length; i++){            
            idsClonar.push(idClonar);
            idClonar = null;
        }

        if(appendStep.length > 0){
            const data = new FormData();      
            data.append("validacion", apiKey());
            data.append("idciclo", idCiclo);
            data.append("steps", JSON.stringify(appendStep));
            data.append("idsclonar", JSON.stringify(idsClonar));        
            const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.runciccfg.padre.getdatostablenextstep, data, source.token);
    
            if( typeof respuesta.data == "string"){
                alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true}); 
            }else{
                datosTabla = respuesta.data;
            }
        }
       
        saveLoadingCiclo(false);

        if(step == null){
            return datosTabla;
        }else{
            return datosTabla[0];
        }         
    }

    const getTablaModalLineas = async (idCiclo, step, regSeleccionados, filterLines=false) => { 

        let datosTabla = [];
        saveLoadingCiclo(true);

        const idDoc = regSeleccionados.filter((reg) => Object.keys(reg)[0] == "runciccfgTab_"+step)[0]["runciccfgTab_"+step].split("-")[1];

        const data = new FormData();      
        data.append("validacion", apiKey());
        data.append("idciclo", idCiclo);
        data.append("step", step);
        data.append("iddoc", idDoc);
        data.append("filterlines", filterLines);
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.runciccfg.padre.gettablalineasmodal, data, source.token);

        if( typeof respuesta.data == "string"){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true}); 
        }else{
            datosTabla = respuesta.data;
        }
       
        saveLoadingCiclo(false);

        return datosTabla;
    }

    const verLineas = async (step, idTabla) => {        
        savePasoTablaVerLineas(step);
        saveTablaLineas([]);
        await getTablaLineas(step, idTabla);        
        saveShowModalLineas(true);
    }

    const getTablaLineas = async (step, idTabla) => {         
        saveLoadingTablaLineas(true); 

        const idDoc = registrosSeleccionados.filter((reg) => Object.keys(reg)[0] == "runciccfgTab_"+(step+1))[0]["runciccfgTab_"+(step+1)].split("-")[1];

        const data = new FormData();      
        data.append("validacion", apiKey());        
        data.append("iddoc", idDoc);        
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.runciccfg.padre.modallineas.datatablelineas.getdata, data, source.token);

        if( typeof respuesta.data == "string"){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true}); 
        }else{
            saveTablaLineas(respuesta.data);
        }  
       
        saveLoadingTablaLineas(false);
    }

    const verInfoOperacion = async (step, idTabla) => {
        saveDatosTablaInfoOperacion([]);
        await getTablaInfoOperacion(step, idTabla);        
        saveShowModalInfoOperacion(true);
    }

    const getTablaInfoOperacion = async (step, idTabla) => {         
        saveLoadingTablaInfoOperacion(true); 

        const idDoc = registrosSeleccionados.filter((reg) => Object.keys(reg)[0] == "runciccfgTab_"+(step+1))[0]["runciccfgTab_"+(step+1)].split("-")[1];

        const data = new FormData();      
        data.append("validacion", apiKey());        
        data.append("iddoc", idDoc);
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.runciccfg.padre.modalinfooperacion.datatableinfooperacion.getdata, data, source.token);

        if( typeof respuesta.data == "string"){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true}); 
        }else{
            saveDatosTablaInfoOperacion(respuesta.data);
        }  
       
        saveLoadingTablaInfoOperacion(false);
    }

    const disabledBtnNext = (step) =>{       
        let deshabilitar = true;      
        
        if(Array.isArray(registrosSeleccionados) && registrosSeleccionados.length > 0){
            const guardar = registrosSeleccionados.filter((reg) => Object.keys(reg)[0] == "runciccfgTab_"+step)                
            guardar.length > 0 ? deshabilitar =  false: deshabilitar = true;
        }

        return deshabilitar;
    }



    const handleSelectRegTable = async (e, idTabla, idTablaLineas) => {
        let target = e.target; // Buscar el elemento padre hasta encontrar un row 
        while (target && !target.id.includes("#row-")) { 
            target = target.parentElement; 
        }
        
        let execAutoIniciar = false;

        if (target) { 
            const idRow = target.id;
            const datos = $("."+idTabla).DataTable().rows().data();            
            const selectedRows = $('#'+idTabla).DataTable().rows( { selected: true } ).data();
            
            let auxRegistrosSeleccionados = registrosSeleccionados;
            let auxDatosTablas = datosTablas;                        

            if(selectedRows.length == 0){                 
    
                // Para deshabilitar los siguientes botones cuando cambiamos la seleccion de un registro en una tabla                
                for (let i = 0; i < auxRegistrosSeleccionados.length; i++) {                    
                    if (Object.keys(auxRegistrosSeleccionados[i])[0] === idTabla) {
                        auxRegistrosSeleccionados.splice(i, 1);
                        // break;
                    }
                }

                // Solo borramos si hacemos click en la primera tabla
                if("runciccfgTab_1" == idTabla){
                    auxDatosTablas = clearNextTables(auxDatosTablas, idTabla);
                }   

            }else{                               
                if(auxRegistrosSeleccionados.length > 0){
                    const contador = auxRegistrosSeleccionados.length;
                    for (let i = 0; i < contador; i++) {
                        if (Object.keys(auxRegistrosSeleccionados[i])[0] === idTabla) {
                            // Editar                            
                            auxRegistrosSeleccionados[i][idTabla] = idRow;                            
                        }else{
                            const guardar = auxRegistrosSeleccionados.filter(reg =>Object.keys(reg)[i] == idTabla)
                            if(guardar.length == 0){
                                // Añadir los siguientes al primero sino existía
                                const aux = { [idTabla] : idRow };
                                auxRegistrosSeleccionados.push(aux);
                            }
                        }
                    }
                    // Para deshabilitar los siguientes botones cuando cambiamos la seleccion de un registro en una tabla
                    for (let i = 0; i < auxRegistrosSeleccionados.length; i++) {
                        if (Object.keys(auxRegistrosSeleccionados[i])[0] === idTabla) {
                            auxRegistrosSeleccionados.splice(i+1);
                            break;
                        }
                    }
                }else{
                    // Añadir el primero                    
                    const datosAux = { [idTabla] : idRow };
                    auxRegistrosSeleccionados.push(datosAux);
                    execAutoIniciar = true;
                }
                
                // Solo borramos si hacemos click en la primera tabla
                if("runciccfgTab_1" == idTabla){
                    auxDatosTablas = clearNextTables(auxDatosTablas, idTabla);
                    execAutoIniciar = true;
                }               

            }

            // saveForceBtnNext(forceBtnNext => forceBtnNext+1)            
            
            let auxIdSel;
            for(let i = 0; i < titleTabs.length; i++){
                auxIdSel = 0;
                if(auxRegistrosSeleccionados.length > 0 && auxRegistrosSeleccionados[0][`runciccfgTab_1`]){                                        
                    auxIdSel = auxRegistrosSeleccionados[0][`runciccfgTab_1`].split("-")[1];
                }else{
                    auxRegistrosSeleccionados = [];
                }
            }

            if(execAutoIniciar){
                saveLoadingCiclo(true);                  
                const auxData = await autoIniciarFull(idRow.split("-")[1], auxRegistrosSeleccionados, true);
                auxDatosTablas = auxData[0];
                auxRegistrosSeleccionados = auxData[1];
            } 

            saveRenderedTitleTabs(await renderTabTitle(titleTabs, titleTabs.length, auxIdSel));
            saveRegistrosSeleccionados(auxRegistrosSeleccionados) 
            saveDatosTablas(auxDatosTablas);
            
            saveLoadingCiclo(false);
        }


    }

    const clearNextTables = (auxDatosTablas, idTabla) => {
        let data=[];
        let encontrado = false;         
        for(let i=0; i<numSteps.length; i++){
            if (("runciccfgTab_"+(i+1)) == idTabla) {
                encontrado = true;
                data.push(auxDatosTablas[i])
            }else if(encontrado){
                let oTable = $(".runciccfgTab_"+(i+1)).DataTable();
                oTable.clear();
                oTable.draw();
            }else{
                data.push(auxDatosTablas[i])
            }
        }
        
        return data;
    }

    const getColumnsDinamyc = () => {        
        let columns = [];
        columns.push({ title: "Articulo", data: "unidad" });
        for(let i=0; i<titleTabs.length; i++){
            const title = titleTabs[i].tipo.split('-')[0];
            columns.push({ title: title, data: `s${i+1}` });
        }        
        return columns;
    }


    const loadOptionsCbo = async (fuente, opcion, options, saveOptions, backUp=false) =>{
        const data = new FormData();
        data.append("validacion", apiKey());                        
        
        const idCookie = await encryptData(cookies.get('id'), appCryptCom);
        data.append('ua', idCookie);
        const nivelCookie = await encryptData(cookies.get('nivel'), appCryptCom);
        data.append('na', nivelCookie);
                    
        // Encriptamos el tag sql. 
        opcion = await encryptData(opcion, appCryptCom);
        data.append(fuente, opcion);                

        if( options == null ){
            let url = null;
            if( fuente == "filter" ){
                url = getApiUrl(window.location.origin)+'/filters/getFilter';
            }else{
                url = getApiUrl(window.location.origin)+'/app/getDataCbo';
            }
            const respuesta = await axios.post(url, data);
            saveOptions(respuesta.data);            
            if(backUp){
                backUpOptionsUbi = respuesta.data;
            }
                
        }

        saveLoadedSelect(true);
    }

    const handleInput = (e, save) => {        
        save(e.target.value)
    }

    const handleCheck = (e) => {        
        if( e.target.checked ){              
            saveValModalIncludeCero(true);
        }else{
            saveValModalIncludeCero(false);
        }
    }

    
    return(
        <div className="App wrapper">    
        <Alert fondo={true} />
        {
            confPantalla !== undefined
            ?
                <Fragment>
                    <Menusup 
                        props = { props }
                    />
                    <Sidebar 
                        props = { props }
                    />
                </Fragment>
            :
            null
        } 
        <div className="content-wrapper">
            <div className="content-header">
            </div>
            <section className="content">
                {
                    !tieneNivel 
                    ?
                        <PermissionRefused
                            traduction={confPantalla.config.trad.components.permissionrefused} 
                        />
                    :
                    <Fragment>
                    {
                        loadedConf === true && confPantalla !== undefined
                        ?
                            <Section
                                // tituloenhtml={true}  
                                titulo={ confPantalla.runciccfg.section.titulo } 
                                icono={ confPantalla.runciccfg.section.icono } 
                                col={ confPantalla.runciccfg.section.col } 
                                idPrin={idCiclo} 
                                wiki={ confPantalla.runciccfg.section.wiki } 
                                recurrencia={codCic}
                                // idPrin={lineaSelect} 
                                // informes={ confPantalla.runciccfg.padre.informes } 
                                // disabledInformes={!loadingCiclo || forceBtnNext ? disabledBtnNext(index+1) : true}
                            > 
                                <MiSelect  
                                    estadoForm=  { confPantalla.runciccfg.padre.estadoform }
                                    val=         { idCiclo  }   
                                    // loading=     { loadingCiclo ? true : false }
                                    loading=     { false }
                                    id=          { confPantalla.runciccfg.padre.idciccfg.id }    
                                    name=        { confPantalla.runciccfg.padre.idciccfg.name }   
                                    label=       { confPantalla.runciccfg.padre.idciccfg.label }    
                                    placeholder= { confPantalla.runciccfg.padre.idciccfg.placeholder }
                                    col=         { confPantalla.runciccfg.padre.idciccfg.col } 
                                    isClearable= { confPantalla.runciccfg.padre.idciccfg.isclearable }
                                    isSearchable={ confPantalla.runciccfg.padre.idciccfg.issearchable }
                                    dataType=    { confPantalla.runciccfg.padre.idciccfg.datatype }
                                    data=        { confPantalla.runciccfg.padre.idciccfg.data }
                                    required=    { confPantalla.runciccfg.padre.idciccfg.required } 
                                    disabled=  { confPantalla.runciccfg.padre.idciccfg.disabled }
                                    readOnly =   { confPantalla.runciccfg.padre.idciccfg.readonly }
                                    disablethisid={confPantalla.runciccfg.padre.idciccfg.disablethisid}
                                    disableids={confPantalla.runciccfg.padre.idciccfg.disableids}
                                    formulario= { {id:0} }   
                                    change= { handleSelectCiclo }
                                />
                                {  loadingCiclo ? 
                                        <SpinnerFloat />
                                    :
                                     null
                                }
                                {
                                    idCiclo != ""
                                    ?
                                        <Button 
                                            clases={ "btn-block mb-3" }
                                            color={ "success" }  
                                            type="button" 
                                            icono={ "fal fa-plus" }   
                                            id={"btnAdd"}     
                                            texto={ " "+confPantalla.runciccfg.padre.btnadd.title }   
                                            accion={ () => showModalFn() } 
                                            disabled={ loadingCiclo ? true : false }
                                        /> 
                                    :
                                        null
                                }
                                {
                                    idCiclo != ""
                                    ?
                                    <div className="ruciccfg-tabs">
                                        <Tabs defaultActiveKey="tab_1" id="tab1" className="mb-4 ruciccfg-div">
                                        {
                                            numSteps.map((linea, index) => {

                                                let lengthTabla = 0;

                                                let tabla = null;
                                                let tablaLineas = null;                                                
                                                lineaSelect = registrosSeleccionados[index] && registrosSeleccionados[index]["runciccfgTab_"+(index+1)]
                                                                                ? lineaSelect = registrosSeleccionados[index]["runciccfgTab_"+(index+1)].split("-")[1] 
                                                                                : lineaSelect = null;                                                
                                                const idDoc = registrosSeleccionados[index] && registrosSeleccionados[index]["runciccfgTab_"+(index+1)]
                                                                ? registrosSeleccionados.filter((reg) => Object.keys(reg)[0] == "runciccfgTab_"+(index+1))[0]["runciccfgTab_"+(index+1)].split("-")[1]  
                                                                : 0
                                                
                                                const defaultAgeNextStep =  datosTablas[index]
                                                                            ? (() => {
                                                                                const found = datosTablas[index].find((row) => row.id === idDoc);
                                                                                // return found && found.idage2 != null && found.idage2 != 0 && found.idage2 != ''
                                                                                // ? found.idage2
                                                                                return found && found.agedef != null && found.idage2 != ''
                                                                                ? found.agedef
                                                                                : cicDefAge;
                                                                            })()
                                                                            : cicDefAge;
                                                                                                                      
                                                const idEstDoc =  datosTablas[index]
                                                                            ? (() => {
                                                                                const found = datosTablas[index].find((row) => row.id === idDoc);
                                                                                return found
                                                                                ? found.idest
                                                                                : 0;
                                                                            })()
                                                                            : 0;
                                                
                                                // Activar o desactivar botón lanzar solicitud un función del tipo de documento que está seleccionado y tipdoc.req de app_cfg
                                                const infoDocSelectThisTable = datosTablas[index]
                                                                                ? datosTablas[index].filter((reg) => reg.id == lineaSelect )
                                                                                : null                                                                                           
                                                const activarBtnLanzarSolicitud = infoDocSelectThisTable && infoDocSelectThisTable[0] && infoDocSelectThisTable[0].idtip == infoDocSelectThisTable[0].tipdocreq
                                                ? true
                                                : false                                                

                                                const btnNext = <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%"}}>
                                                                    <div>
                                                                        {
                                                                            activarBtnLanzarSolicitud == true && idDoc != 0 && idEstDoc == 8
                                                                            ?
                                                                                <NavLink 
                                                                                    to={"/request/"+idDoc} 
                                                                                    className="mb-3 btn btn-flat mr-1 btn-success"
                                                                                >
                                                                                    <i className="fal fa-arrow-to-right mr-1" style={{marginRight:5}} />
                                                                                    { confPantalla.runciccfg.padre.btnnext.title  }
                                                                                </NavLink>
                                                                            :
                                                                            numSteps.length == (index+1)
                                                                            ?
                                                                            <Button
                                                                                index={"btn-"+(index+1)}
                                                                                clases={ " mb-3" }
                                                                                color={ "success" }  
                                                                                type="button" 
                                                                                icono={ "fal fa-arrow-to-right mr-1" }   
                                                                                id={"btnnext-"+(index+1)}     
                                                                                texto={ confPantalla.runciccfg.padre.btnfin.title }   
                                                                                accion={ () => nextStep(index+1, defaultAgeNextStep) }
                                                                                disabled={ loadingCiclo || idEstDoc == 9 ? true : false }
                                                                            />
                                                                            :
                                                                            <Button
                                                                                index={"btn-"+(index+1)}
                                                                                clases={ " mb-3" }
                                                                                color={ "success" }  
                                                                                type="button" 
                                                                                icono={ "fal fa-arrow-to-right mr-1" }   
                                                                                id={"btnnext-"+(index+1)}     
                                                                                texto={ confPantalla.runciccfg.padre.btnnext.title }   
                                                                                accion={ () => nextStep(index+1, defaultAgeNextStep) }
                                                                                disabled={ !loadingCiclo || forceBtnNext ? disabledBtnNext(index+1) : true }
                                                                            />
                                                                        }
                                                                        {
                                                                            idDoc > 0 && activarBtnLanzarSolicitud
                                                                            ?
                                                                                <NavLink 
                                                                                    to={"/request/"+idDoc} 
                                                                                    className="mb-3 btn btn-flat mr-1 btn-primary"
                                                                                >
                                                                                    <i className="fal fa-file-invoice" style={{marginRight:5}} />
                                                                                    { " "+confPantalla.runciccfg.padre.btnsolicitud.title }
                                                                                </NavLink>
                                                                            :
                                                                                <Button
                                                                                    index={"btn-"+(index+1)}
                                                                                    clases={ " mb-3" }
                                                                                    color={ "primary" }  
                                                                                    type="button" 
                                                                                    icono={ "fal fa-file-invoice" }   
                                                                                    id={"btnreq-"+(index+1)}     
                                                                                    texto={ " "+confPantalla.runciccfg.padre.btnsolicitud.title }   
                                                                                    accion={ null }
                                                                                    disabled={ true }
                                                                                />                                                                          
                                                                        }                                                                     
                                                                    </div>
                                                                    <div>
                                                                        <Button
                                                                            index={"btn-"+(index+1)}
                                                                            clases={ " mb-3" }
                                                                            color={ "warning" }  
                                                                            type="button" 
                                                                            icono={ "fal fa-info-circle" }   
                                                                            id={"btninfo-"+(index+1)}     
                                                                            texto={ " "+confPantalla.runciccfg.padre.btninfolineas.title }
                                                                            accion={ () => verLineas(index, "infoLineasTab_"+(index+1)) }
                                                                            disabled={ !loadingCiclo || forceBtnNext ? disabledBtnNext(index+1) : true }
                                                                        />
                                                                        {/* {
                                                                            varOrigen == "supply" 
                                                                            ?
                                                                                <Button
                                                                                    index={"btn-"+(index+1)}
                                                                                    clases={ " mb-3" }
                                                                                    color={ "warning" }
                                                                                    type="button" 
                                                                                    icono={ "fal fa-info-circle" }   
                                                                                    id={"btninfolin-"+(index+1)}     
                                                                                    texto={ " "+confPantalla.runciccfg.padre.btninfooperacion.title }                                                                           
                                                                                    accion={ () => verInfoOperacion(index, "infoOperacionTab_"+(index+1)) }
                                                                                    disabled={ !loadingCiclo || forceBtnNext ? disabledBtnNext(index+1) : true }
                                                                                />
                                                                            :
                                                                                null
                                                                        } */}
                                                                        {
                                                                            idDoc > 0
                                                                            ?
                                                                                <NavLink 
                                                                                    to={"/edirap/"+idDoc} 
                                                                                    className="mb-3 btn btn-flat mr-1 btn-primary"
                                                                                >
                                                                                    <i className="fal fa-eye" style={{marginRight:5}} />
                                                                                    { " "+confPantalla.runciccfg.padre.btnver.title }
                                                                                </NavLink>
                                                                            :
                                                                                <Button
                                                                                    index={"btn-"+(index+1)}
                                                                                    clases={ " mb-3" }
                                                                                    color={ "primary" }  
                                                                                    type="button" 
                                                                                    icono={ "fal fa-eye" }   
                                                                                    id={"btnver-"+(index+1)}     
                                                                                    texto={ " "+confPantalla.runciccfg.padre.btnver.title }   
                                                                                    accion={ null }
                                                                                    disabled={ true }
                                                                                />                                                                    
                                                                        }
                                                                        <InformesBtn
                                                                            select =     { confPantalla.runciccfg.padre.informes.select }
                                                                            formulario = { {id: lineaSelect} }
                                                                            getRegistro = { confPantalla.runciccfg.padre.informes.getregistro }
                                                                            loadReg =    { false }
                                                                            estadoForm=  { "" } 
                                                                            traduction=  { confPantalla.config.trad.components }
                                                                            btnGenerar= { confPantalla.runciccfg.padre.informes.btngenerar.title }
                                                                            logoContext={logo}
                                                                            apiKeyContext={apiKey}
                                                                            confAppContext={confApp}
                                                                            appCryptComContext={appCryptCom}
                                                                            buttonInLine={true}
                                                                            disabled={ !loadingCiclo || forceBtnNext ? disabledBtnNext(index+1) : true }
                                                                        />
                                                                    </div>
                                                                </div>
                                                                                                
                                                tabla = <div id={"divTab_"+(index+1)} onClick={(e, idTabla)=> handleSelectRegTable(e, "runciccfgTab_"+(index+1), "infoLineasTab_"+(index+1))}>
                                                            <MiDataTableRunciccfg 
                                                                    estadoForm= { "" }
                                                                    formulario={ {id:0} }
                                                                    id={"runciccfgTab_"+(index+1)}
                                                                    columnas={confPantalla.runciccfg.padre.datatable.columns}
                                                                    data={datosTablas[index]}
                                                                    buttons={confPantalla.runciccfg.padre.datatable.buttons}
                                                                    ordering={confPantalla.runciccfg.padre.datatable.ordering}
                                                                    order={confPantalla.runciccfg.padre.datatable.order}
                                                                    searching={confPantalla.runciccfg.padre.datatable.searching}
                                                                    paging={confPantalla.runciccfg.padre.datatable.paging}
                                                                    select={confPantalla.runciccfg.padre.datatable.select}
                                                                    pagelength={confPantalla.runciccfg.padre.datatable.pagelength}
                                                                    columnactions={confPantalla.runciccfg.padre.datatable.columnactions.title}
                                                                    linkColumns={confPantalla.runciccfg.padre.datatable.linkColumns}
                                                                    traduction={confPantalla.config.trad.components.datatable}
                                                                    registrosSeleccionados={registrosSeleccionados}
                                                                    datosTablas={datosTablas}
                                                                    selectId={{id:lineaSelect}}                                                                                                                        
                                                            />
                                                        </div>;                                                
                                                if(datosTablas[index]){
                                                    lengthTabla = datosTablas[index].length
                                                }else{
                                                    lengthTabla = 0;
                                                }
                                                if(renderedTitleTabs[index]){                                                    
                                                    const enlace = document.getElementById(`tab1-tab-tab_${(index+1)}`);
                                                    if (enlace) {
                                                       if(infoDocSelectThisTable && infoDocSelectThisTable[0] && infoDocSelectThisTable[0].idest == 9){
                                                            // si está aceptado/realizado (9) VERDE
                                                            enlace.style.backgroundColor = '#28a745';
                                                            enlace.style.borderColor = '#28a745';
                                                            enlace.style.color = '#fff';
                                                       }else if(infoDocSelectThisTable && infoDocSelectThisTable[0] && (infoDocSelectThisTable[0].idest == 10 || infoDocSelectThisTable[0].idest == 12)){
                                                            // si está OBSOLETO/NO REALIZADO (10,12) ROJO                                                           
                                                            enlace.style.backgroundColor = '#dc3545';
                                                            enlace.style.borderColor = '#dc3545';
                                                            enlace.style.color = '#fff';
                                                       }else if(infoDocSelectThisTable && infoDocSelectThisTable[0]){
                                                            // Cualquier otro estado NARANJA
                                                            enlace.style.backgroundColor = '#ffc107';
                                                            enlace.style.borderColor = '#ffc107';
                                                            enlace.style.color = '#000000';
                                                       }else{
                                                            // Azul
                                                            enlace.style.backgroundColor = '#007bff';
                                                            enlace.style.borderColor = '#007bff';
                                                            enlace.style.color = '#fff';
                                                       }                                                                                                   
                                                    }
                                                }
                                                return(                                                    
                                                    <Tab                                                         
                                                        index={(index+1)} 
                                                        eventKey={"tab_"+(index+1)}                                                        
                                                        title={ renderedTitleTabs[index] ? renderedTitleTabs[index] : (index+1) }>
                                                            {btnNext}
                                                            {tabla}                                                                                               
                                                    </Tab>
                                                )
                                            })
                                        }
                                        </Tabs>
                                    </div>
                                    :
                                        null
                                }
                                                                                                            
                            </Section>
                        :
                            <LoadingPage />
                        }
                    </Fragment>
                }
                
            </section>
        </div>
        <Footer /> 
        {
            showModal 
            ?
                <Modal
                    show={showModal}
                    onHide={ () => saveShowModal(false)}                            
                    aria-labelledby="example-custom-modal-styling-title"
                    centered={true}                    
                    dialogClassName="modal-90w" 
                    >
                    <Modal.Header closeButton>                        
                    </Modal.Header>                            
                    <Modal.Body>
                        <FormRow>
                            <MiSelect  
                                estadoForm=  { "" }
                                val=         { valModalCentro }   
                                loading=     { false }
                                id=          { confPantalla.runciccfg.padre.modaliniciar.idcen.id }    
                                name=        { confPantalla.runciccfg.padre.modaliniciar.idcen.name }   
                                label=       { confPantalla.runciccfg.padre.modaliniciar.idcen.label }    
                                placeholder= { confPantalla.runciccfg.padre.modaliniciar.idcen.placeholder }
                                col=         { confPantalla.runciccfg.padre.modaliniciar.idcen.col } 
                                isClearable= { confPantalla.runciccfg.padre.modaliniciar.idcen.isclearable }
                                isSearchable={ confPantalla.runciccfg.padre.modaliniciar.idcen.issearchable }
                                dataType=    { confPantalla.runciccfg.padre.modaliniciar.idcen.datatype }
                                data=        { confPantalla.runciccfg.padre.modaliniciar.idcen.data }
                                required=    { confPantalla.runciccfg.padre.modaliniciar.idcen.required } 
                                disabled=  { confPantalla.runciccfg.padre.modaliniciar.idcen.disabled }
                                readOnly =   { confPantalla.runciccfg.padre.modaliniciar.idcen.readonly }
                                disablethisid={confPantalla.runciccfg.padre.modaliniciar.idcen.disablethisid}
                                disableids={ confPantalla.runciccfg.padre.modaliniciar.idcen.disableids}
                                formulario= { {id:0} }   
                                change= { (selectedItem, nameOfComponent) => handleSelect(selectedItem, nameOfComponent, saveValModalCentro) }
                            />
                            <MiSelect  
                                estadoForm=  { "" }
                                val=         { valModalResponsable }   
                                loading=     { false }
                                id=          { confPantalla.runciccfg.padre.modaliniciar.idage2.id }    
                                name=        { confPantalla.runciccfg.padre.modaliniciar.idage2.name }   
                                label=       { confPantalla.runciccfg.padre.modaliniciar.idage2.label }    
                                placeholder= { confPantalla.runciccfg.padre.modaliniciar.idage2.placeholder }
                                col=         { confPantalla.runciccfg.padre.modaliniciar.idage2.col } 
                                isClearable= { confPantalla.runciccfg.padre.modaliniciar.idage2.isclearable }
                                isSearchable={ confPantalla.runciccfg.padre.modaliniciar.idage2.issearchable }
                                dataType=    { confPantalla.runciccfg.padre.modaliniciar.idage2.datatype }
                                data=        { confPantalla.runciccfg.padre.modaliniciar.idage2.data }
                                required=    { confPantalla.runciccfg.padre.modaliniciar.idage2.required } 
                                disabled=  { confPantalla.runciccfg.padre.modaliniciar.idage2.disabled }
                                readOnly =   { confPantalla.runciccfg.padre.modaliniciar.idage2.readonly }
                                disablethisid={confPantalla.runciccfg.padre.modaliniciar.idage2.disablethisid}
                                disableids={ confPantalla.runciccfg.padre.modaliniciar.idage2.disableids}
                                formulario= { {id:0} }   
                                change= { (selectedItem, nameOfComponent) => handleSelect(selectedItem, nameOfComponent, saveValModalResponsable) }
                            />
                        </FormRow>
                        <FormRow>
                            <MiSelect  
                                estadoForm=  { confPantalla.runciccfg.padre.modaliniciar.estadoform }
                                val=         { idNuevoCiclo  }   
                                loading=     { false }
                                id=          { confPantalla.runciccfg.padre.modaliniciar.documentos.id }    
                                name=        { confPantalla.runciccfg.padre.modaliniciar.documentos.name }   
                                label=       { confPantalla.runciccfg.padre.modaliniciar.documentos.label }    
                                placeholder= { confPantalla.runciccfg.padre.modaliniciar.documentos.placeholder }
                                col=         { confPantalla.runciccfg.padre.modaliniciar.documentos.col } 
                                isClearable= { confPantalla.runciccfg.padre.modaliniciar.documentos.isclearable }
                                isSearchable={ confPantalla.runciccfg.padre.modaliniciar.documentos.issearchable }
                                dataType=    { confPantalla.runciccfg.padre.modaliniciar.documentos.datatype }
                                data=        { confPantalla.runciccfg.padre.modaliniciar.documentos.data }
                                required=    { confPantalla.runciccfg.padre.modaliniciar.documentos.required } 
                                disabled=  { confPantalla.runciccfg.padre.modaliniciar.documentos.disabled }
                                readOnly =   { confPantalla.runciccfg.padre.modaliniciar.documentos.readonly }
                                disablethisid={confPantalla.runciccfg.padre.modaliniciar.documentos.disablethisid}
                                disableids={confPantalla.runciccfg.padre.modaliniciar.documentos.disableids}
                                formulario= { {id:0} }   
                                change= { (selectedItem, nameOfComponent) => handleSelect(selectedItem, nameOfComponent, saveIdNuevoCiclo, true) }
                            />
                        </FormRow>
                        <FormRow>
                            <FormInput                                                        
                                estadoForm= { confPantalla.runciccfg.padre.modaliniciar.estadoform }
                                value=      { valModalDescripcion }
                                loading=    { loadReg ? true : false }
                                id=         { confPantalla.runciccfg.padre.modaliniciar.nom1.id }   
                                type=       { confPantalla.runciccfg.padre.modaliniciar.nom1.type }  
                                name=       { confPantalla.runciccfg.padre.modaliniciar.nom1.name }   
                                label=      { confPantalla.runciccfg.padre.modaliniciar.nom1.label }                                                       
                                placeholder={ confPantalla.runciccfg.padre.modaliniciar.nom1.placeholder }    
                                col=        { confPantalla.runciccfg.padre.modaliniciar.nom1.col } 
                                required=   { confPantalla.runciccfg.padre.modaliniciar.nom1.required }
                                readonly=   { confPantalla.runciccfg.padre.modaliniciar.nom1.readonly }                                                
                                disabled=   { confPantalla.runciccfg.padre.modaliniciar.nom1.disabled }
                                change=     { e => handleInput(e, saveValModalDescripcion) }
                                onBlur=     {null} 
                            />
                        </FormRow>
                        <FormRow>
                            <CheckIos                                
                                val= { valModalIncludeCero }
                                name={null}
                                label={ confApp.supply.controles.modaliniciar.check.label }                                
                                id={'checkfirma'}
                                col={"12"}
                                change={ handleCheck }
                                required={ false }
                                disabled={ false }                               
                            />
                        </FormRow>
                        <p className="font-italic text-center">{ confPantalla.runciccfg.padre.modaliniciar.txtrequired.title }</p>
                        <p className="font-italic text-center">{confPantalla.runciccfg.padre.help.title}</p>
                        <button 
                            type="button" 
                            className="btn btn-flat btn-success btn-block " 
                            onClick={ (e) => nuevoCiclo() }
                            disabled={ idNuevoCiclo == 0 || valModalCentro == 0 || valModalResponsable == 0 || loadingNuevoCiclo == true ? true : false}
                            >
                            {confPantalla.runciccfg.padre.btncrear.title}
                        </button>
                        {  loadingNuevoCiclo ? 
                                <div className='mt-4' style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                    <Spinner animation="border" />
                                </div>
                            :
                            null
                        }
                    </Modal.Body>                            
                </Modal>
            :
                    null
        }
        {
            showModalNextStep 
            ?
                <Modal
                    show={showModalNextStep}
                    onHide={ () => saveShowModalNextStep(false)}                            
                    aria-labelledby="example-custom-modal-styling-title"
                    centered={true}                    
                    dialogClassName="modal-90w" 
                    >
                    <Modal.Header closeButton>
                        {getHeaderModalNextStep(infoModalNextStep)}
                    </Modal.Header>                          
                    <Modal.Body>
                        {  loadingModalNextStep ? 
                                <div className='mt-4' style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                    <Spinner animation="border" />
                                </div>
                            :
                            null
                        }
                        {/* <div className="row" >
                            <div className="col-12">
                                <div className="row justify-content-md-center">                                   
                                    <div className="col-md-12 col-lg-2">
                                        <div className={ infoModalNextStep.opt == 0 ? "alert alert-danger alertHelp text-center"  : "alert alert-success alertHelp text-center" } role="alert">
                                            <h5 style={{marginBottom : "0px"}}>
                                                {confPantalla.runciccfg.padre.helpmodal.opcional.title}
                                                {
                                                    infoModalNextStep.opt == 0 
                                                    ? <i className="ml-1 fal fa-square" style={{fontSize : "1.2em"}}></i>
                                                    : <i className="ml-1 fal fa-check-square" style={{fontSize : "1.2em"}}></i>
                                                }
                                            </h5>
                                        </div>
                                    </div>
                                    <div className="col-md-12 col-lg-2">
                                        <div className={infoModalNextStep.divi == 0 ? "alert alert-danger alertHelp text-center"  : "alert alert-success alertHelp text-center"} role="alert">
                                            <h5 style={{marginBottom : "0px"}}>
                                                {confPantalla.runciccfg.padre.helpmodal.divisible.title}
                                                {
                                                    infoModalNextStep.divi == 0 
                                                    ? <i className="ml-1 fal fa-square" style={{fontSize : "1.2em"}}></i>
                                                    : <i className="ml-1 fal fa-check-square" style={{fontSize : "1.2em"}}></i>
                                                }
                                            </h5>
                                        </div>
                                    </div>
                                    <div className="col-md-12 col-lg-2">
                                        <div className={infoModalNextStep.apl == 0 ? "alert alert-danger alertHelp text-center"  : "alert alert-success alertHelp text-center"} role="alert">
                                            <h5 style={{marginBottom : "0px"}}>
                                                {confPantalla.runciccfg.padre.helpmodal.apilable.title}
                                                {
                                                    infoModalNextStep.apl == 0 
                                                    ? <i className="ml-1 fal fa-square" style={{fontSize : "1.2em"}}></i>
                                                    : <i className="ml-1 fal fa-check-square" style={{fontSize : "1.2em"}}></i>
                                                }
                                            </h5>
                                        </div>
                                    </div>                                                                                         
                                </div>
                            </div>
                        </div> */}                        
                        {
                            datosTablas[stepBtnNext] && datosTablas[stepBtnNext].length > 0
                            ?
                                <MiDataTableRunciccfg
                                    formulario={{id:0}}
                                    id={"tableModalDocs"}
                                    columnas={confPantalla.runciccfg.padre.datatablemodaldocs.columns}
                                    data={datosTablas[stepBtnNext]}
                                    buttons={confPantalla.runciccfg.padre.datatablemodaldocs.buttons}
                                    ordering={confPantalla.runciccfg.padre.datatablemodaldocs.ordering}
                                    order={confPantalla.runciccfg.padre.datatablemodaldocs.order}
                                    searching={confPantalla.runciccfg.padre.datatablemodaldocs.searching}
                                    paging={confPantalla.runciccfg.padre.datatablemodaldocs.paging}
                                    select={confPantalla.runciccfg.padre.datatablemodaldocs.select}
                                    pagelength={confPantalla.runciccfg.padre.datatablemodaldocs.pagelength}                           
                                    columnactions={confPantalla.runciccfg.padre.datatablemodaldocs.title}
                                    traduction={confPantalla.config.trad.components.datatable}
                                    functionAfterSelect={getTxtHelp}                            
                                />
                            :
                                null
                        }
                        {/* <div className="row" >
                            <div className="col-12">
                                <div className="row justify-content-md-center">
                                    {getTxtHelp(null, null, null, null, true)}
                                </div>
                            </div>
                        </div> */}
                        <FormRow clases='alert-warning mt-3 px-2 py-2 rounded-lg'>
                            <MiSelect  
                                estadoForm=  { "" }
                                val=         { valResponsable }   
                                loading=     { loadReg ? true : false }
                                id=          { confPantalla.runciccfg.padre.modalresponsable.idage2.id }    
                                name=        { confPantalla.runciccfg.padre.modalresponsable.idage2.name }   
                                label=       { confPantalla.runciccfg.padre.modalresponsable.idage2.label+"*" }    
                                placeholder= { confPantalla.runciccfg.padre.modalresponsable.idage2.placeholder }
                                col=         { 12 } 
                                isClearable= { confPantalla.runciccfg.padre.modalresponsable.idage2.isclearable }
                                isSearchable={ confPantalla.runciccfg.padre.modalresponsable.idage2.issearchable }
                                dataType=    { confPantalla.runciccfg.padre.modalresponsable.idage2.datatype }
                                data=        { confPantalla.runciccfg.padre.modalresponsable.idage2.data }
                                required=    { confPantalla.runciccfg.padre.modalresponsable.idage2.required } 
                                disabled=  { confPantalla.runciccfg.padre.modalresponsable.idage2.disabled }
                                readOnly =   { confPantalla.runciccfg.padre.modalresponsable.idage2.readonly }
                                disablethisid={confPantalla.runciccfg.padre.modalresponsable.idage2.disablethisid}
                                disableids={ confPantalla.runciccfg.padre.modalresponsable.idage2.disableids}
                                formulario= { {id:0} }   
                                change= { (selectedItem, nameOfComponent) => handleSelectResponsable(selectedItem, nameOfComponent) }
                            />
                        </FormRow>
                        <p className='font-italic text-center'>{confPantalla.runciccfg.padre.helpmodal.txtrequired.title}</p>
                        <FormRow>
                            <InformesBtn
                                select =     { confPantalla.runciccfg.padre.informes.select }
                                formulario = { {id: idDocInformesModalNextStep} }
                                getRegistro = { confPantalla.runciccfg.padre.informes.getregistro }
                                loadReg =    { false }
                                estadoForm=  { "" } 
                                traduction=  { confPantalla.config.trad.components }
                                btnGenerar= { confPantalla.runciccfg.padre.informes.btngenerar.title }
                                logoContext={logo}
                                apiKeyContext={apiKey}
                                confAppContext={confApp}
                                appCryptComContext={appCryptCom}
                                buttonInLine={true}
                                disabled={ false }
                            />
                        </FormRow>
                        <MiDataTableRunciccfg
                            formulario={{id:0}}
                            id={"tableModalLineas"}
                            columnas={confPantalla.runciccfg.padre.datatablemodallineas.datatable.columns}
                            data={tablaModalNextStep}
                            buttons={confPantalla.runciccfg.padre.datatablemodallineas.datatable.buttons}
                            ordering={confPantalla.runciccfg.padre.datatablemodallineas.datatable.ordering}
                            order={confPantalla.runciccfg.padre.datatablemodallineas.datatable.order}
                            searching={confPantalla.runciccfg.padre.datatablemodallineas.datatable.searching}
                            paging={confPantalla.runciccfg.padre.datatablemodallineas.datatable.paging}
                            select={confPantalla.runciccfg.padre.datatablemodallineas.datatable.select}
                            pagelength={confPantalla.runciccfg.padre.datatablemodallineas.datatable.pagelength}                           
                            columnactions={confPantalla.runciccfg.padre.datatablemodallineas.datatable.title}
                            traduction={confPantalla.config.trad.components.datatable}
                            cantidad={cantidadEdi}
                            saveCantidad={saveCantidadEdi}                            
                            step={stepBtnNext}
                            infoCiclo={infoCiclo[stepBtnNext-1]}
                            selectUbi={confPantalla.runciccfg.padre.datatablemodallineas.ubi}
                            optionSelectUbi={optionsUbi}
                            ubicaciones={ubicacionesEdi}
                            saveUbicaciones={saveUbicacionesEdi}
                            selectAllOnLoad={true}
                            revisado={revisadoEdi}
                            saveRevisado={saveRevisadoEdi}
                        />
                    {  loadingCiclo ? 
                            <div className='mt-4' style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                <Spinner animation="border" />
                            </div>
                        :
                        null
                    }
                    <button type="button" className="btn btn-flat btn-success mt-3 float-right " onClick={ (e) => okNextStepModal(e) } disabled={loadingCiclo || valResponsable < 1 ? true : false}>
                            {" "+confPantalla.runciccfg.padre.btnnext.title}
                    </button>
                    <button type="button" className="mr-2 btn btn-flat btn-primary mt-3 float-right " onClick={ (e) => guardadoProvisional(e) } disabled={loadingCiclo ? true : false}>
                            {" "+confPantalla.runciccfg.padre.btnguardar.title}
                    </button>
                    <button type="button" className="mr-2 btn btn-flat btn-danger mt-3 float-right " onClick={ () => saveShowModalNextStep(false) } disabled={loadingCiclo ? true : false}>
                            {" "+confPantalla.runciccfg.padre.btncancelar.title}
                    </button>
                    </Modal.Body>                            
                </Modal>
            :
                    null
        }
        {
            showModalLineas
            ?
                <Modal
                    show={showModalLineas}
                    onHide={ () => saveShowModalLineas(false)}                            
                    aria-labelledby="example-custom-modal-styling-title"
                    centered={true}                    
                    dialogClassName="modal-90w" 
                    >
                    <Modal.Header closeButton>
                        <h4>{confPantalla.runciccfg.padre.modallineas.header.title}</h4>
                    </Modal.Header>                          
                    <Modal.Body>
                        {  loadingTablaLineas ? 
                                <div className='mt-4' style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                    <Spinner animation="border" />
                                </div>
                            :
                                null
                        }
                        <MiDataTableVerLineas 
                            estadoForm= { "" }
                            formulario={ {id:0} }
                            id={"tablaLineas"}
                            columnas={getColumnsDinamyc()}
                            data={tablaLineas}
                            buttons={confPantalla.runciccfg.padre.modallineas.datatablelineas.buttons}
                            ordering={confPantalla.runciccfg.padre.modallineas.datatablelineas.ordering}
                            order={confPantalla.runciccfg.padre.modallineas.datatablelineas.order}
                            searching={confPantalla.runciccfg.padre.modallineas.datatablelineas.searching}
                            paging={confPantalla.runciccfg.padre.modallineas.datatablelineas.paging}
                            select={confPantalla.runciccfg.padre.modallineas.datatablelineas.select}
                            pagelength={confPantalla.runciccfg.padre.modallineas.datatablelineas.pagelength}                            
                            columnactions={confPantalla.runciccfg.padre.modallineas.datatablelineas.columnactions.title}
                            linkColumns={confPantalla.runciccfg.padre.modallineas.datatablelineas.linkColumns}
                            traduction={confPantalla.config.trad.components.datatable}
                            pasoTablaVerLineas={pasoTablaVerLineas}                  
                        />
                                            
                    <button type="button" className="mr-2 btn btn-flat btn-danger mt-3 float-right " onClick={ () => saveShowModalLineas(false) }>
                            {confPantalla.runciccfg.padre.modallineas.btncerrar.title}
                    </button>
                    </Modal.Body>                            
                </Modal>
            :
                    null
        }
        {
            showModalResponsable
            ?
                <Modal
                    show={showModalResponsable}
                    onHide={ () => saveShowModalResponsable(false)}                            
                    aria-labelledby="example-custom-modal-styling-title"
                    centered={true}                    
                    dialogClassName="modal-90w "
                    backdrop="static" 
                    backdropClassName='runciccfgmodalrespbackdrop'                                       
                >                     
                    <Modal.Body>
                        <MiSelect  
                            estadoForm=  { "" }
                            val=         { valResponsable }   
                            loading=     { loadReg ? true : false }
                            id=          { confPantalla.runciccfg.padre.modalresponsable.idage2.id }    
                            name=        { confPantalla.runciccfg.padre.modalresponsable.idage2.name }   
                            label=       { confPantalla.runciccfg.padre.modalresponsable.idage2.label }    
                            placeholder= { confPantalla.runciccfg.padre.modalresponsable.idage2.placeholder }
                            col=         { confPantalla.runciccfg.padre.modalresponsable.idage2.col } 
                            isClearable= { confPantalla.runciccfg.padre.modalresponsable.idage2.isclearable }
                            isSearchable={ confPantalla.runciccfg.padre.modalresponsable.idage2.issearchable }
                            dataType=    { confPantalla.runciccfg.padre.modalresponsable.idage2.datatype }
                            data=        { confPantalla.runciccfg.padre.modalresponsable.idage2.data }
                            required=    { confPantalla.runciccfg.padre.modalresponsable.idage2.required } 
                            disabled=  { confPantalla.runciccfg.padre.modalresponsable.idage2.disabled }
                            readOnly =   { confPantalla.runciccfg.padre.modalresponsable.idage2.readonly }
                            disablethisid={confPantalla.runciccfg.padre.modalresponsable.idage2.disablethisid}
                            disableids={ confPantalla.runciccfg.padre.modalresponsable.idage2.disableids}
                            formulario= { {id:0} }   
                            change= { (selectedItem, nameOfComponent) => handleSelectResponsable(selectedItem, nameOfComponent) }
                        />
                        {  loadingUpdateResponsable ? 
                                <div className='mt-4' style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                    <Spinner animation="border" />
                                </div>
                            :
                            null
                        }                                                
                    </Modal.Body>
                    <Modal.Footer>
                        <div className='text-right'>
                            <button 
                                    className="btn btn-success mt-1 mr-1"
                                    onClick={ () => updateResponsable() }
                                    disabled={valResponsable == 0 ? true : false}                                        
                            >
                                {confPantalla.runciccfg.padre.modalresponsable.btnaceptar.title}
                            </button>                            
                        </div>
                    </Modal.Footer>                            
                </Modal>
            :
                null
        }
        {
            showModalInfoOperacion
            ?
                <Modal
                    show={showModalInfoOperacion}
                    onHide={ () => saveShowModalInfoOperacion(false)}                            
                    aria-labelledby="example-custom-modal-styling-title"
                    centered={true}                    
                    dialogClassName="modal-90w" 
                    >
                    <Modal.Header closeButton>
                        <h4>{confPantalla.runciccfg.padre.modallineas.header.title}</h4>
                    </Modal.Header>                          
                    <Modal.Body>
                        {  loadingTablaInfoOperacion ? 
                                <div className='mt-4' style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                    <Spinner animation="border" />
                                </div>
                            :
                                null
                        }
                        <MiDataTable 
                            estadoForm= { "" }
                            formulario={ {id:0} }
                            id={"tablaInfoOperacion"}
                            columnas={confPantalla.runciccfg.padre.modalinfooperacion.datatableinfooperacion.columns}
                            data={datosTablaInfoOperacion}
                            buttons={confPantalla.runciccfg.padre.modalinfooperacion.datatableinfooperacion.buttons}
                            ordering={confPantalla.runciccfg.padre.modalinfooperacion.datatableinfooperacion.ordering}
                            order={confPantalla.runciccfg.padre.modalinfooperacion.datatableinfooperacion.order}
                            searching={confPantalla.runciccfg.padre.modalinfooperacion.datatableinfooperacion.searching}
                            paging={confPantalla.runciccfg.padre.modalinfooperacion.datatableinfooperacion.paging}
                            select={confPantalla.runciccfg.padre.modalinfooperacion.datatableinfooperacion.select}
                            pagelength={confPantalla.runciccfg.padre.modalinfooperacion.datatableinfooperacion.pagelength}                            
                            columnactions={confPantalla.runciccfg.padre.modalinfooperacion.datatableinfooperacion.columnactions.title}
                            linkColumns={confPantalla.runciccfg.padre.modalinfooperacion.datatableinfooperacion.linkColumns}
                            traduction={confPantalla.config.trad.components.datatable}                                           
                        />
                         <p className="font-italic text-center">{confPantalla.runciccfg.padre.modalinfooperacion.help.title}</p>                   
                        <button type="button" className="mr-2 btn btn-flat btn-danger mt-3 float-right " onClick={ () => saveShowModalInfoOperacion(false) }>
                                {confPantalla.runciccfg.padre.modallineas.btncerrar.title}
                        </button>
                    </Modal.Body>                            
                </Modal>
            :
                    null
        }
        </div>

    );

}
export default RunCicCfg